<div
  #modalContent
  class="l-modal04__contents u-modal-size-pc-768 l-modal04__contents--bg-gray5 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="search-flight-again-modal-title"
>
  <div #modalHead class="l-modal04__header js-modal-head">
    <div class="p-modal-head04">
      <h1 id="modalTitle" class="p-modal-head04__title" [innerHTML]="'label.modifySearch.title' | staticMsg"></h1>
      <!-- [お気に入り、検索履歴 ボタンエリア] -->
      <div class="l-top-navi__function-area">
        <div class="l-top-navi__function-item" *ngIf="!this.notLogin">
          <button
            id="search-flight-again-modal-button-2"
            class="l-top-navi__function-btn l-top-navi__function-btn--history"
            (click)="clickHistory()"
          >
            <span class="u-visually-hidden" [innerHTML]="'label.searchHistory.title' | staticMsg"></span>
          </button>
        </div>
        <div class="l-top-navi__function-item" *ngIf="!this.notLogin">
          <button
            id="search-flight-again-modal-button-3"
            class="l-top-navi__function-btn l-top-navi__function-btn--favorites"
            (click)="clickFavorite()"
          >
            <span class="u-visually-hidden" [innerHTML]="'label.Favorite.title' | staticMsg"></span>
          </button>
        </div>
        <!--閉じるボタン-->
        <div class="l-top-navi__function-item">
          <button
            id="search-flight-again-modal-button-1"
            class="l-top-navi__function-btn js-modal-close"
            (click)="this.modalClose()"
            style="
              display: block;
              width: 24px;
              height: 24px;
              background: url(assets/images/icon_close_primary_24.svg) no-repeat center center;
              background-size: cover;
            "
          >
            <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
          </button>
        </div>
      </div>
      <!-- [お気に入り、検索履歴 ボタンエリア] -->
    </div>
  </div>

  <div #modalBody class="l-modal04__body js-modal-body">
    <div class="p-modal-body04">
      <asw-search-flight-body-cont
        #aswSearchFlightBodyCont
        [information]="information"
        [onewayInformationList]="onewayInformationList"
        (changeOptionOpenEvent)="changeOptionOpen($event)"
      ></asw-search-flight-body-cont>
    </div>
  </div>
  <div class="l-modal04__footer js-modal-footer is-shadow">
    <div #modalFooter class="p-modal-foot04">
      <button
        id="search-flight-again-modal-button-4"
        class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
        (throttleClick$)="this.clickSearch($event)"
        aswThrottleClick
      >
        <span class="c-btn-primary__text" [innerHTML]="'label.search' | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
